"use strict";

var _defineProperty = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$FORMAT_PATTE, _exports$VALIDATION_E;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@8base/utils");

exports.FORMAT_PATTERN = (_exports$FORMAT_PATTE = {}, _defineProperty(_exports$FORMAT_PATTE, utils_1.TEXT_FORMATS.UNFORMATTED, /.*/), _defineProperty(_exports$FORMAT_PATTE, utils_1.TEXT_FORMATS.NAME, /.*/), _defineProperty(_exports$FORMAT_PATTE, utils_1.SMART_FORMATS.ADDRESS, /.*/), _defineProperty(_exports$FORMAT_PATTE, utils_1.TEXT_FORMATS.EMAIL, /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i), _defineProperty(_exports$FORMAT_PATTE, utils_1.TEXT_FORMATS.PHONE, /^(0|[1-9][0-9]{9})$/i), _defineProperty(_exports$FORMAT_PATTE, utils_1.TEXT_FORMATS.SSN, /^(?!666|000|9\d{2})\d{3}[- ]{0,1}(?!00)\d{2}[- ]{0,1}(?!0{4})\d{4}$/), _defineProperty(_exports$FORMAT_PATTE, utils_1.TEXT_FORMATS.EIN, /^\d{2}[- ]{0,1}\d{7}$/), _defineProperty(_exports$FORMAT_PATTE, utils_1.DATE_FORMATS.DATE, /\d{4}-[01]\d-[0-3]\d/), _defineProperty(_exports$FORMAT_PATTE, utils_1.DATE_FORMATS.DATETIME, /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/), _exports$FORMAT_PATTE);
exports.VALIDATION_ERROR = (_exports$VALIDATION_E = {}, _defineProperty(_exports$VALIDATION_E, utils_1.DATE_FORMATS.DATE, function () {
  return 'Invalid date.';
}), _defineProperty(_exports$VALIDATION_E, utils_1.DATE_FORMATS.DATETIME, function () {
  return 'Invalid datetime.';
}), _defineProperty(_exports$VALIDATION_E, utils_1.SMART_FORMATS.ADDRESS, function () {
  return '';
}), _defineProperty(_exports$VALIDATION_E, utils_1.TEXT_FORMATS.EIN, function () {
  return 'Invalid Employer Identification Number.';
}), _defineProperty(_exports$VALIDATION_E, utils_1.TEXT_FORMATS.EMAIL, function () {
  return 'Invalid email.';
}), _defineProperty(_exports$VALIDATION_E, utils_1.TEXT_FORMATS.NAME, function () {
  return '';
}), _defineProperty(_exports$VALIDATION_E, utils_1.TEXT_FORMATS.PHONE, function () {
  return 'Invalid phone number.';
}), _defineProperty(_exports$VALIDATION_E, utils_1.TEXT_FORMATS.SSN, function () {
  return 'Invalid Social Security Number.';
}), _defineProperty(_exports$VALIDATION_E, utils_1.TEXT_FORMATS.UNFORMATTED, function () {
  return '';
}), _defineProperty(_exports$VALIDATION_E, "FORMAT", function FORMAT(format) {
  return "Value doesn't match ".concat(format, " format.");
}), _defineProperty(_exports$VALIDATION_E, "IS_REQUIRED", function IS_REQUIRED() {
  return 'Value is required';
}), _defineProperty(_exports$VALIDATION_E, "MAX_FIELD_SIZE", function MAX_FIELD_SIZE(maxFieldSize) {
  return "Maximum allowed field size is ".concat(maxFieldSize, ". It was exceeded.");
}), _defineProperty(_exports$VALIDATION_E, "MAX_PRECISION", function MAX_PRECISION(maxPrecision) {
  return "Maximum allowed precision is ".concat(maxPrecision, ". It was exceeded.");
}), _defineProperty(_exports$VALIDATION_E, "MAX_VALUE", function MAX_VALUE(maxValue) {
  return "Value is greater than maximum allowed value ".concat(maxValue, ".");
}), _defineProperty(_exports$VALIDATION_E, "MIN_VALUE", function MIN_VALUE(minValue) {
  return "Value is lower than minimum allowed value ".concat(minValue, ".");
}), _defineProperty(_exports$VALIDATION_E, "NOT_A_JSON", function NOT_A_JSON(parseError) {
  return "Value isn't a valid JSON: ".concat(parseError, ".");
}), _defineProperty(_exports$VALIDATION_E, "NOT_A_NUMBER", function NOT_A_NUMBER() {
  return "Value isn't a number";
}), _exports$VALIDATION_E);